import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import TrainingVideos from "./TrainingVideo";

export const TrainingVideosModule = () => {
    let { path } = useRouteMatch();

    return (
    
        <Switch>
          <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
                <TrainingVideos />
          </ProtectedRoute>        
          <Route>
            <NotFound />
          </Route>
        </Switch>
      
    );
  };
  
  export default TrainingVideosModule;